/**
 * Admin screens use HTTP + Redux when this is true.
 *
 * - **Explicit:** `REACT_APP_ADMIN_API_ENABLED=true` or `false` in `.env` (restart `npm start` after changes).
 * - **If unset:** defaults to **on in development** (so `npm start` + local API works without env).
 *   In **production** builds, defaults to **off** unless you set `=true` (avoids broken admin on static deploys without a backend).
 */
function parseAdminApiFlag(raw) {
  if (raw == null) return null;
  const s = String(raw).toLowerCase().trim();
  if (s === "") return null;
  if (s === "true" || s === "1" || s === "yes") return true;
  if (s === "false" || s === "0" || s === "no") return false;
  return null;
}

export function isAdminApiEnabled() {
  const parsed = parseAdminApiFlag(process.env.REACT_APP_ADMIN_API_ENABLED);
  if (parsed !== null) return parsed;
  return process.env.NODE_ENV === "development";
}
